import { ChiTietSoLuongTonComponent } from './../chi-tiet-so-luong-ton/chi-tiet-so-luong-ton.component';
import { element } from 'protractor';
import { TimKiemNangCaoListComponent } from './../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { FunctionPublic } from './../../../dung-chung/__function/common_function';
import { DeNghiMuaHangService } from '../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		ViewRef
	}
from '@angular/core';
import { DatePipe } from '@angular/common';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { KhoDeNghiXuatKhoService } from '../kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { KhoDeNghiXuatKho, KhoDeNghiXuatKhoChiTiet} from '../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';

import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import moment from 'moment';


@Component({
	selector: 'm-kho-de-nghi-xuat-kho-edit',
	templateUrl: './kho-de-nghi-xuat-kho-edit.component.html',
	styleUrls: ['../kho-de-nghi-xuat-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class KhoDeNghiXuatKhoEditComponent implements OnInit {
	//#region Config
	CONFIG: CommonConFig;
	//#endregion Config

	//#region Các trường focus cho các tag trong form 
	@ViewChildren('focusGhiChu') focusGhiChu;
	@ViewChildren('focusSoPhieuDHB') focusSoPhieuDHB;
	@ViewChildren('focusSL') focusSL;
	@ViewChildren('focusDetail') focusDetail;

	@ViewChild('focusDetail', {static: true}) focusDetailValue: ElementRef;

	@ViewChild('fileUploadImport', { static: false }) fileUploadImport : ElementRef;
	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	//#endregion Các trường focus cho các tag trong form 

	//#region Column Table
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MAHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TENHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QUYCACH',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 5,
            name: 'DONVITINH',
            displayName: 'Đơn vị tính',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLUONG',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLUONGTHUCXUAT',
            displayName: 'SL thực xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPDN',
            displayName: 'Bộ phận đề nghị',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'BPSD',
            displayName: 'Bộ phận sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'MUCDICHSUDUNG',
            displayName: 'Mục đích sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOLO',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SOMAY',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'NGAYCAN',
            displayName: 'Ngày cần',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 10,
        //     name: 'GHICHU',
        //     displayName: 'Ghi chú',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'SOPHIEUDHB',
        //     displayName: 'Số phiếu ĐHB',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'MAKH',
        //     displayName: 'Mã KH',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		// {
        //     stt: 10,
        //     name: 'TENKH',
        //     displayName: 'Tên KH',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		
	];
	extendColumn = [
        {
            stt: 99,
            name: 'ACTIONS',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	]

	//#endregion Column Table

	//#region  Mat Select
	/* Mat select search cho khach hang */
	listListBP : any[] = [];
	selectListBP : string = '';
	filteredListBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListBPFilterCtrl: string = '';
	haveElementListBP: boolean = false;

	listListBP2 : any[] = [];
	selectListBP2 : string = '';
	filteredListBP2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListBP2FilterCtrl: string = '';
	haveElementListBP2: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho khach hang */
	listListSPDHB : any[] = [];
	selectListSPDHB : string = '';
	filteredListSPDHB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListSPDHBFilterCtrl: string = '';
	haveElementListSPDHB: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecord = 0;
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	//#endregion Mat Select
	
	//#region Khai báo biến
	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	processImport: boolean = true;		// Có đang chạy import
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoDeNghiXuatKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = true;   // Loading khi mở dialog
	isCopy: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	KhoDeNghiXuatKhoForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	KhoDeNghiXuatKhoSubForm: FormGroup;				//Form phiếu đề nghị
	hasSubFormErrors: boolean = false;

	ImportHHForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KhoDeNghiXuatKhoItem: KhoDeNghiXuatKho;

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKhoDeNghiXuatKho: KhoDeNghiXuatKhoChiTiet[] = [];

	/* Danh sách tình trạng phiếu */
	Tinhtrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KHOPDNXK_LUUNHAP',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'KHOPDNXK_CHODUYET',
		},
		{
			id: 3,
			name: 'Bị trả lại',
			value: 'KHOPDNXK_BITRALAI',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KHOPDNXK_HOANTAT',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KHOPDNXK_DAHUY',
		},
		{
			id: 6,
			name: 'Chờ xuất kho',
			value: 'KHOPDNXK_CHOXUATKHO',
		},
		{
			id: 7,
			name: 'Đã xóa',
			value: 'KHOPDNXK_DAXOA'
		}
	];

	openTimKiemNangCao = false;
	optionLoaiPhieu: any[] = [];

	openDHB: boolean = false;

	flagChangeLoaiPhieu = '';

	
	//#endregion Khai báo biến

	//#region Phím tắt nhanh
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode && !this.openTimKiemNangCao && (!this.processImport && !this.viewLoading)) {
			this.back();
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE.KeyCombine.keycode && (!this.processImport && !this.viewLoading)) {
			this.onSubmit(1);
		}
		if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode && (!this.processImport && !this.viewLoading)){
			this.onSubmit(2);
		}
		if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode && (!this.processImport && !this.viewLoading)){
			this.onSubmit(0);
		}
	}
	//#endregion Phím tắt nhanh

	//#region  Constructor
	constructor(
		public dialogRef: MatDialogRef<KhoDeNghiXuatKhoEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KhoDeNghiXuatKhoService: KhoDeNghiXuatKhoService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private KhoDeNghiXuatKhoFB: FormBuilder,
		private KhoDeNghiXuatKhoSubFB: FormBuilder,
		private ImportHHFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private deNghiMuaHangService: DeNghiMuaHangService,
	) { 
		this.dialogRef.disableClose = true;
	}
	//#endregion Constructor

	//#region Load Data
	async ngOnInit() {
		this.viewLoading = false;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		
		/*Get data from list when open dialog */
		this.KhoDeNghiXuatKhoItem = this.data.data;
		this.isCopy = this.data.isCopy;

		/*Load all dropdown and create form */
		this.ListLoaiPhieu();
		this.ListBP();
		this.ListId_HH();
		this.ListSPDHB();
		this.createForm();
		/*Handel escape event in dialog*/

		if(!this.KhoDeNghiXuatKhoItem.Sophieu) this.createBillNumber().then(r => {this.KhoDeNghiXuatKhoForm.controls['SOPHIEU'].setValue(r);});
		
		this.KhoDeNghiXuatKhoSubForm.get('MAHH').valueChanges.subscribe(newValue=>{
			this.filterId_HH(newValue);
		})

		//#region xử lý file excel
		// this.KhoDeNghiXuatKhoService.data_import.subscribe(res => {
		// 	if(res != null && res != undefined){
		// 		res.forEach(element =>{
		// 			const _detail = new KhoDeNghiXuatKhoChiTiet();
		// 			_detail.clear();
		// 			_detail.isError = element.isError;
		// 			_detail.messageError = element.messageError;

		// 			let errorMessageArray = _detail.messageError.split(",");
		// 			if(errorMessageArray != null && errorMessageArray != undefined){
		// 				let ton = 0;
		// 				for(let i = 0; i < errorMessageArray.length; i++){
		// 					switch (i) {
		// 						case 0:{
		// 							if(errorMessageArray[i] == "null"){
		// 								let index = this.listId_HH.findIndex(x => x.MaHH == element.MaHH)
		// 								if(index > -1){
		// 									_detail.IdHh = this.listId_HH[index].Id_HH
		// 									_detail.MaHH = this.listId_HH[index].MaHH;
		// 									_detail.TenHH = this.listId_HH[index].TenHH;
		// 									_detail.QuyCach = this.listId_HH[index].QuyCach;
		// 									_detail.TenDvt = this.listId_HH[index].TenDVT;
		// 									_detail.Dvt = this.listId_HH[index].DVT;
		// 									ton = this.listId_HH[index].SoLuongTon;
		// 									this.tmpChiTietKhoDeNghiXuatKho.forEach(e => {
		// 										if(e.IdHh == _detail.IdHh){
		// 											ton -= e.Soluong;
		// 										}
		// 									});
		// 								}
		// 								else{
		// 									_detail.MaHH = element.MaHH;
		// 									_detail.isError = true;
		// 									errorMessageArray[i] = "Không tìm thấy mã hàng tương ứng; ";
		// 								}
		// 							}
		// 							else{
		// 								_detail.MaHH = element.MaHH;
		// 								_detail.isError = true;
		// 								element.MaHH == null ? errorMessageArray[i] = "Mã hàng hóa không được để trống; " : null;
		// 							}
		// 							break;
		// 						}
		// 						case 1:{
		// 							if(element.Soluong == null){
		// 								_detail.Soluong = 0;
		// 								errorMessageArray[i] = "Số lượng bị lỗi, vui lòng kiểm tra lại; "
		// 							}else{
		// 								if(this.listId_HH.findIndex(x => x.MaHH == element.MaHH) > -1){
		// 									if(ton < element.Soluong){
		// 										errorMessageArray[i] = "Số lượng vượt quá số lượng tồn, vui lòng kiểm tra lại; ";
		// 										_detail.Soluong = element.Soluong;
		// 										_detail.isError = true;
		// 									}
		// 								}
		// 								_detail.Soluong = element.Soluong;
		// 							}

		// 							break;
		// 						}
		// 						case 2:{
		// 							element.MucDichSuDung == null ? errorMessageArray[i] = "Mục đích sử dụng không được để trống; " 
		// 													: _detail.MucDichSuDung = element.MucDichSuDung;
		// 							break;
		// 						}
		// 						case 3:{
		// 							
		// 							if(errorMessageArray[i] == "null"){
		// 								if(!element.NgayCanString){
		// 									_detail.isError = true;
		// 									element.NgayCanString == null ? errorMessageArray[i] = "Ngày cần không được để trống; " : null;
		// 									break;
		// 								}
		// 								//Regex cho ngày tháng dạng dd/mm/yyyy hoặc dd-mm-yyyy hoặc dd.mm.yyyy
		// 								var regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g;
		// 								var patt = new RegExp(regex);
		// 								var found = element.NgayCanString.match(patt);
										
		// 								if(found != null){
		// 									var dateParts = element.NgayCanString.split("/");
		// 									var dateObject = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
		// 									_detail.NgayCan = moment(dateObject).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		// 								}
		// 								else{
		// 									_detail.NgayCan = '';
		// 									_detail.isError = true;
		// 									errorMessageArray[i] = "Lỗi định dạng ngày tháng ngày cần, vui lòng kiểm tra lại; "
		// 								}	
		// 							}
		// 							else{
		// 								_detail.isError = true;
		// 								element.NgayCanString == null ? errorMessageArray[i] = "Ngày cần bị lỗi, vui lòng kiểm tra lại; " : null;
		// 							}
		// 							break;
		// 						}
		// 						case 4:{
		// 							_detail.GhiChu = element.GhiChu;
									
		// 							break;
		// 						}

		// 						case 5:{
		// 							
		// 							if(element.DatHangSoPhieu){
										
		// 								if(errorMessageArray[i] == "null"){
		// 									_detail.DatHangSoPhieu = element.DatHangSoPhieu;
		// 									var index = this.listListSPDHB.findIndex(x => x.SoPhieu === _detail.DatHangSoPhieu);
		// 									if(index > -1){
		// 										_detail.DatHangId = this.listListSPDHB[index].Id;
		// 										_detail.MaKH = this.listListSPDHB[index].MaKH;
		// 										_detail.TenKH = this.listListSPDHB[index].TenKH;
		// 									}else{
		// 										_detail.isError = true;
		// 										errorMessageArray[i] = "Số phiếu ĐHB không tồn tại";
		// 									}
		// 								}
		// 							}
		// 							break;
		// 						}
		// 					}
		// 				}
		// 				_detail.messageError = "";
		// 				errorMessageArray.forEach(elementMessage => {
		// 					if(elementMessage != "null"){
		// 						_detail.messageError += elementMessage;
		// 					}
		// 				})
		// 				if(_detail.messageError[0] == ";")
		// 					_detail.messageError = _detail.messageError.substring(1).trim();
		// 				if(_detail.messageError[_detail.messageError.length - 1] == ";")
		// 					_detail.messageError = _detail.messageError.substring(0, _detail.messageError.length - 1).trim();

		// 				if(!_detail.isError){
		// 					let indexDetail = this.tmpChiTietKhoDeNghiXuatKho.findIndex(x => x.IdHh == _detail.IdHh);
		// 					if(indexDetail > -1){
		// 						this.tmpChiTietKhoDeNghiXuatKho[indexDetail].Soluong = (Number(_detail.Soluong) + Number(this.tmpChiTietKhoDeNghiXuatKho[indexDetail].Soluong));
		// 						this.tmpChiTietKhoDeNghiXuatKho[indexDetail].MucDichSuDung += ', '+_detail.MucDichSuDung;
		// 						if(_detail.GhiChu) this.tmpChiTietKhoDeNghiXuatKho[indexDetail].GhiChu += ', '+_detail.GhiChu;
		// 						this.tmpChiTietKhoDeNghiXuatKho[indexDetail].GhiChu += '';
		// 					}
		// 					else{
		// 						this.tmpChiTietKhoDeNghiXuatKho.push(_detail);
								
		// 					}
		// 				}
		// 				else{
		// 					this.tmpChiTietKhoDeNghiXuatKho.push(_detail);
		// 				}
		// 			}
		// 			else{
		// 				this.layoutUtilsService.showErorr('Lỗi đọc dữ liệu file, vui lòng thử lại');
		// 				return;
		// 			}
		// 		})
		// 		console.log(this.tmpChiTietKhoDeNghiXuatKho);
		// 		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
		// 		this.processImport = false;
		// 		this.changeDetectView();
		// 	}
		// });
		//#endregion xử lý file excel
		this.processImport = false;
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		//this.changeDetect.detectChanges();
	}

	ngAfterViewInit() {
		//this.changeDetect.detectChanges();
	}
	
	ngOnDestroy() {
		this.clearDataImport();
	}

	ListLoaiPhieu(){
		this.DungChungService.layDanhSachLoaiPhieu(1).subscribe(res =>{
			if(res && res.status == 1){
				this.optionLoaiPhieu = res.data;
				if(this.KhoDeNghiXuatKhoItem.IdDn > 0){
					this.optionLoaiPhieu.forEach(x => {
						if(x.Id.toString() == this.KhoDeNghiXuatKhoItem.LoaiPhieu.toString()){
							this.openDHB = x.OpenDHB;
						}
					});
					this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(''+this.KhoDeNghiXuatKhoItem.LoaiPhieu);
				}
				else this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(res.data[0].Id.toString());
				this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value.toString();
			}else{
				this.layoutUtilsService.showErorr("Không tải được danh sách loại phiếu");
			}
			this.changeDetect.detectChanges();
		});
	}

	//#endregion Load Data

	//#region Tạo và chỉnh sửa form
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		var idPhongBan = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		//this.tokenStorage.getCoCauId().subscribe(a => {idPhongBan = ''+a;});

		/*Group các Form */
		this.KhoDeNghiXuatKhoForm = this.KhoDeNghiXuatKhoFB.group({
			SOPHIEU: [this.KhoDeNghiXuatKhoItem.Sophieu, Validators.required],
			NGAYLAP: [!(this.KhoDeNghiXuatKhoItem.Ngaytao == undefined || this.KhoDeNghiXuatKhoItem.Ngaytao == '') ? this.KhoDeNghiXuatKhoItem.Ngaytao : new Date(), Validators.required],
			NGUOILAP: [this.KhoDeNghiXuatKhoItem.Nguoitao > 0 ? this.KhoDeNghiXuatKhoItem.TenNguoitao : tenNguoiLap],
			TRANGTHAI: [(this.KhoDeNghiXuatKhoItem.Tinhtrang == '')? this.Tinhtrang[0].value: this.KhoDeNghiXuatKhoItem.Tinhtrang],
			DESCTRANGTHAI: [(this.KhoDeNghiXuatKhoItem.DescTinhTrang == '')?  this.Tinhtrang[0].name: this.KhoDeNghiXuatKhoItem.DescTinhTrang],
			LOAIPHIEU: [(!this.KhoDeNghiXuatKhoItem.LoaiPhieu)? '' : ''+this.KhoDeNghiXuatKhoItem.LoaiPhieu, Validators.required]
		});
		let minDataSL = 0.01;
		this.KhoDeNghiXuatKhoSubForm = this.KhoDeNghiXuatKhoSubFB.group({
			MAHH: ['', Validators.required],
			TENHH: [''],
			QUYCACH: [''],
			DVT: [''],
			KHOILUONG: ['0,00', Validators.compose([Validators.required,Validators.maxLength(24),Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])],
			SLTON: ['0,00', Validators.compose([Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])],
			NGAYCAN: [new Date(), Validators.required],
			MUCDICHSUDUNG: ['',Validators.required],
			//GHICHU:[''],
			// SOPHIEUDHB:[''],
			// MAKH:[''],
			// TENKH:[''],
			BPDN : ['', Validators.required],
			BPSD : ['', Validators.required],
			SOLO : [''],
			SOMAY : ['']
		});

		this.ImportHHForm = this.ImportHHFB.group({
			FileDuLieu: [''],
		});
		
		if(this.KhoDeNghiXuatKhoItem.IdDn > 0) this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoItem.LoaiPhieu.toString();

		/*Disable các trường dữ liệu không thay đổi */
		this.KhoDeNghiXuatKhoForm.controls["SOPHIEU"].disable();
		this.KhoDeNghiXuatKhoForm.controls["NGUOILAP"].disable();
		this.KhoDeNghiXuatKhoForm.controls["NGAYLAP"].disable();
		this.KhoDeNghiXuatKhoForm.controls["DESCTRANGTHAI"].disable();
		//this.KhoDeNghiXuatKhoForm.controls["PHONGBAN"].disable();


		this.KhoDeNghiXuatKhoSubForm.controls["TENHH"].disable();
		this.KhoDeNghiXuatKhoSubForm.controls["QUYCACH"].disable();
		this.KhoDeNghiXuatKhoSubForm.controls["DVT"].disable();
		this.KhoDeNghiXuatKhoSubForm.controls["SLTON"].disable();
		// this.KhoDeNghiXuatKhoSubForm.controls["MAKH"].disable();
		// this.KhoDeNghiXuatKhoSubForm.controls["TENKH"].disable();
		// this.KhoDeNghiXuatKhoSubForm.controls["GIARECOMMEND"].disable();

		this.tmpChiTietKhoDeNghiXuatKho = this.KhoDeNghiXuatKhoItem.ChiTiet;
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];

		// this.selectListKH = this.KhoDeNghiXuatKhoForm.controls["MAKH"].value;

	}
	//#endregion Tạo và chỉnh sửa form

	//#region Lấy tiều đề
	getTitle(): string {
		if(this.KhoDeNghiXuatKhoItem.IdDn > 0) return `CHỈNH SỬA PHIẾU ĐỀ NGHỊ XUẤT KHO`
		return `THÊM MỚI PHIẾU ĐỀ NGHỊ XUẤT KHO `;
	}
	//#endregion Lấy tiêu đề

	//#region Thao tác thêm hàng, xóa hàng
	addHang(){
		this.hasSubFormErrors = false;
		const controls = this.KhoDeNghiXuatKhoSubForm.controls;
		/** check form */
		if (this.KhoDeNghiXuatKhoSubForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			//let indexList = [];
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.KhoDeNghiXuatKhoSubForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasSubFormErrors = true;
			return;
		}
		

		// if(this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls['SLTON'].value) == 0){
		// 	const message = 'Số lượng tồn kho hiện tại của hàng hoá không còn.';
		// 	this.focusSL.first.nativeElement.focus();
		// 	this.layoutUtilsService.showErorr(message);
		// 	return false;
		// }

		if(this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls['KHOILUONG'].value) < 0.01){
			const message = 'Số lượng phải lớn hơn 0.';
			this.focusSL.first.nativeElement.focus();
			this.layoutUtilsService.showErorr(message);
			return false;
		}

		// if(this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls['KHOILUONG'].value) > this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls['SLTON'].value)){
		// 	const message = 'Số lượng không được vượt số lượng tồn.';
		// 	this.focusSL.first.nativeElement.focus();
		// 	this.layoutUtilsService.showErorr(message);
		// 	return false;
		// }

		let item = new KhoDeNghiXuatKhoChiTiet();
		let IdHH = +this.selectId_HH;
		this.listId_HH.forEach(el => {
			if(IdHH == el.Id_HH){
				item.IdHh = el.Id_HH;
				item.MaHH = el.MaHH;
				item.TenHH = el.TenHH;
				item.QuyCach = el.QuyCach;
				item.Dvt = el.DVT;
				item.TenDvt = el.TenDVT;
			}
		});
		item.Soluong = +this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls["KHOILUONG"].value);
		item.NgayCan = moment(this.KhoDeNghiXuatKhoSubForm.controls["NGAYCAN"].value).format('YYYY-MM-DD');
		item.MucDichSuDung = this.KhoDeNghiXuatKhoSubForm.controls["MUCDICHSUDUNG"].value;
		//item.GhiChu = this.KhoDeNghiXuatKhoSubForm.controls["GHICHU"].value;
		// item.DatHangId = +this.KhoDeNghiXuatKhoSubForm.controls["SOPHIEUDHB"].value;
		// item.MaKH = this.KhoDeNghiXuatKhoSubForm.controls["MAKH"].value;
		// item.TenKH = this.KhoDeNghiXuatKhoSubForm.controls["TENKH"].value;
		item.BPDN = +this.KhoDeNghiXuatKhoSubForm.controls["BPDN"].value;
		item.BPSD = +this.KhoDeNghiXuatKhoSubForm.controls["BPSD"].value;
		item.SoLo = this.KhoDeNghiXuatKhoSubForm.controls["SOLO"].value ?  this.KhoDeNghiXuatKhoSubForm.controls["SOLO"].value : "";
		item.SoMay = this.KhoDeNghiXuatKhoSubForm.controls["SOMAY"].value ? this.KhoDeNghiXuatKhoSubForm.controls["SOMAY"].value : "";
		this.listListBP.forEach(bp => {
			if(bp.Id_PB == item.BPDN) item.TenBPDN = bp.TenPB;
			if(bp.Id_PB == item.BPSD) item.TenBPSD = bp.TenPB;
		})
		this.listListSPDHB.forEach(el => {
			if(el.Id == item.DatHangId) item.DatHangSoPhieu = el.SoPhieu;
		})

		// -------------- Thêm vào danh sách --------------------------
		let flag = true;
		this.tmpChiTietKhoDeNghiXuatKho.forEach(e => {
			//----------------- Đã tồn tại -----------------------
			if(e.IdHh == item.IdHh){
				if(!this.openDHB){
					if(e.BPSD == item.BPSD && e.BPDN == item.BPDN && e.SoMay == item.SoMay && e.SoLo == item.SoLo && item.NgayCan == e.NgayCan){
						e.Soluong += item.Soluong;
						e.MucDichSuDung += ', '+item.MucDichSuDung;
						if(item.GhiChu) e.GhiChu += ', '+item.GhiChu;
						flag = false;
					}
				}
				if(this.openDHB){
					if(item.DatHangId){
						if(e.DatHangId == item.DatHangId && e.BPDN == item.BPDN && e.BPSD == item.BPSD && e.SoMay == item.SoMay && e.SoLo == item.SoLo && item.NgayCan == e.NgayCan){
							e.Soluong += item.Soluong;
							e.MucDichSuDung += ', '+item.MucDichSuDung;
							if(item.GhiChu) e.GhiChu += ', '+item.GhiChu;
							flag = false;
						}
					}else{
						if(!e.DatHangId && e.BPDN == item.BPDN && e.BPSD == item.BPSD && e.SoMay == item.SoMay && e.SoLo == item.SoLo && item.NgayCan == e.NgayCan){
							e.Soluong += item.Soluong;
							e.MucDichSuDung += ', '+item.MucDichSuDung;
							if(item.GhiChu) e.GhiChu += ', '+item.GhiChu;
							flag = false;
						}
					}	
				}
			}
		});

		if(flag) this.tmpChiTietKhoDeNghiXuatKho.push(item);
		let tmp = this.tmpChiTietKhoDeNghiXuatKho;

		this.resetSubForm();
		//setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
		this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
		this.changeDetect.detectChanges();
	}

	deleteItem(item: any){
		let index = this.tmpChiTietKhoDeNghiXuatKho.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKhoDeNghiXuatKho.splice(index, 1);
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	deleteHang(item: any){
		const index = this.tmpChiTietKhoDeNghiXuatKho.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKhoDeNghiXuatKho.splice(index, 1);
		}
		let tmp = this.tmpChiTietKhoDeNghiXuatKho;
		this.tmpChiTietKhoDeNghiXuatKho = [];
		this.tmpChiTietKhoDeNghiXuatKho = [...tmp];
		// setTimeout(() => {
		// 	this.focusDetail.first.nativeElement.focus();
		// }, 0);
		this.changeDetect.detectChanges();
	}
	//#endregion Thao tác thêm hàng, xóa hàng

	//#region Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		
		if(this.KhoDeNghiXuatKhoItem.Tinhtrang == this.Tinhtrang[0].value || this.KhoDeNghiXuatKhoItem.Tinhtrang == ''){
			this.extendColumn.forEach(element => {
				this.availableColumns.splice(this.availableColumns.length, 0 ,element);
			});
			this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		}
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	//#endregion Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng

	//#region Lấy danh sách bộ phận
	ListBP(select: boolean = false){
		const res = this.DungChungService.listBoPhanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.viewLoading = false;
				this.listListBP = res.data;
				this.listListBP2 = res.data;
				this.filteredListBP.next(this.listListBP.slice());
				this.filteredListBP2.next(this.listListBP2.slice());
				this.changeDetect.detectChanges();
	
			};
		});
		
	}
	filterListBP() {
		if (!this.listListBP) {
			return;
		}
		// get the search keyword
		let search = this.ListBPFilterCtrl;
		if (!search) {
			this.filteredListBP.next(this.listListBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListBP.next(
			this.listListBP.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}

	filterListBP2() {
		if (!this.listListBP2) {
			return;
		}
		// get the search keyword
		let search = this.ListBP2FilterCtrl;
		if (!search) {
			this.filteredListBP2.next(this.listListBP2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListBP2.next(
			this.listListBP2.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy danh sách phòng ban

	//#region Lấy danh sách số phiếu DHB
	ListSPDHB(select: boolean = false){
		const res = this.KhoDeNghiXuatKhoService.liteSPDHB().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.viewLoading = false;
				this.listListSPDHB = res.data;
				this.filteredListSPDHB.next(this.listListSPDHB.slice());
				this.changeDetect.detectChanges();
	
			};
		});
		
	}
	filterListSPDHB() {
		if (!this.listListSPDHB) {
			return;
		}
		// get the search keyword
		let search = this.ListSPDHBFilterCtrl;
		if (!search) {
			this.filteredListSPDHB.next(this.listListSPDHB.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListSPDHB.next(
			this.listListSPDHB.filter(ts =>
				ts.SoPhieu.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetect.detectChanges();
	}
	//#endregion Lấy danh sách phòng ban

	//#region Hỗ trợ format dữ liệu form, validate
	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.KhoDeNghiXuatKhoSubForm.controls[controlName].value.replace(/,/g, "");
			if(!this.KhoDeNghiXuatKhoSubForm.controls[controlName].invalid){
				this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
					this.f_currency(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf('.') == 0 && tmpValue.length == 1){
				tmpValue = 0;
			}
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		}
		else{
			this.KhoDeNghiXuatKhoSubForm.controls[controlName].setValue(''+event.target.value);
		}
	}

	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		
		if (found != null) {
			return false;;
		}
		if (count >= 2) {
			return false;;
		}
		return true;
	}

	validateInvalidSubForm(isAddDetail: boolean = false){
		this.hasSubFormErrors = false;
		const controls = this.KhoDeNghiXuatKhoSubForm.controls;
		//this.valueSLTon = this.formatComparenumber(this.KhoDeNghiXuatKhoSubForm.controls["KHOILUONG"].value);
		//this.KhoDeNghiXuatKhoSubForm.controls["KHOILUONG"].setValidators([Validators.compose([Validators.required,Validators.maxLength(24), Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
		if (this.KhoDeNghiXuatKhoSubForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.KhoDeNghiXuatKhoSubForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						var abc=invalidElements[i].attributes.getNamedItem("formcontrolname").value
						if(elementControl.status == "INVALID"){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>{
				controls[controlName].markAsTouched()
			});
			this.hasSubFormErrors = false;
			return false;
		}

		if(!isAddDetail){
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}

	forcusAnotherEmptyField(control: any){
		Object.keys(control).forEach(controlName =>{

			if(control[controlName].value == null || control[controlName].value == undefined
							|| control[controlName].value == ''){

				// if(controlName == 'GHICHU'){
				// 	setTimeout(() => this.focusGhiChu.first.nativeElement.focus(), 0);
				// }
			}

			this.changeDetect.detectChanges();
		});
	}

	maxNumberValidator(control: AbstractControl) {
		if(control.value != null){
			let vlControl = +control.value.replace(/,/g, "");
			let vlSlTon = +this.formatComparenumber(control.parent.controls['SLTON'].value);
			if (vlControl > 0 && vlControl > vlSlTon) {
			  return { maxNumberValidator: true };
			}
		}
		return null;
	}

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '' || value == '0') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}

	dateToDDMMYYYY(__data: any){
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2)+"/"+("0" + (__date.getMonth() + 1)).slice(-2)+"/"+__date.getFullYear();
	}

	// formatComparenumber(number: string){
	// 	return +number.replace(/,/g, "");
	// }
	//#endregion Hỗ trợ format dữ liệu form , validate

	//#region Tạo số phiếu tự động
	async createBillNumber(){
		var category_path = "DNXK";
		var res = await this.DungChungService.getBillNumber(category_path).toPromise().then( r => { return r});
		if(res && res.status == 1){
			return res.data;
		}
		else{
			this.layoutUtilsService.showErorr("Không thể lấy số phiếu tự động.");
		}
	}
	//#endregion Tạo số phiếu tự động

	//#region Chuyển trạng thái phiếu
	checkGuiDuyet(checked: boolean = false){
		if(checked){
			this.KhoDeNghiXuatKhoForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[1].name);
			this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[1].value);
		}else{
			this.KhoDeNghiXuatKhoForm.controls['DESCTRANGTHAI'].setValue(this.Tinhtrang[0].name);
			this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[0].value);
		}
	}
	//#endregion Chuyển trạng thái phiếu

	//#region Thoát form
	back(){
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd : this.saveAddedTTHV
		});
	}
	//#endregion Thoát form
	
	//#region Xử lý save và gọi api
	onSubmit(action: number) { // 0 là lưu nháp 1 là lưu trờ về 2 là lưu ở lại
		const controls = this.KhoDeNghiXuatKhoForm.controls;
		/** check form */
		if (this.KhoDeNghiXuatKhoForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			//let indexList = [];
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.KhoDeNghiXuatKhoForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}


		if(this.tmpChiTietKhoDeNghiXuatKho.length == 0){
			const message = 'Vui lòng thêm ít nhất một hàng hóa vào danh sách chi tiết.';
			this.layoutUtilsService.showErorr(message);
			// setTimeout(() => {
			// 	this.focusDetail.first.nativeElement.focus();
			// }, 0);
			return false;
		}

		// Kiểm tra danh sách chi tiết
		let recordTrue = [];
		this.tmpChiTietKhoDeNghiXuatKho.forEach(itElement => {
			if(itElement.isError == false || itElement.isError == null) recordTrue.push(itElement);
		});

		if(recordTrue.length == 0){
			const message = 'Vui lòng chỉnh sửa dữ liệu lỗi trước khi lưu.';
			this.layoutUtilsService.showErorr(message);
			return;
		}

		recordTrue.forEach(x => {
			x.Soluong = this.formatComparenumber(x.Soluong.toString());
		});

		
		const data = new KhoDeNghiXuatKho();
		data.clear();
		data.Sophieu = this.KhoDeNghiXuatKhoForm.controls["SOPHIEU"].value;
		data.LoaiPhieu = +this.KhoDeNghiXuatKhoForm.controls["LOAIPHIEU"].value;
		data.Tinhtrang = (action == 0)? "KHOPDNXK_LUUNHAP" : "KHOPDNXK_CHODUYET";
		data.ChiTiet = recordTrue;
		if(action == 1 || action == 2){
			const _sophieu: string = data.Sophieu;
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
	
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.changeDetect.detectChanges();
					return;
				}
				if (this.KhoDeNghiXuatKhoItem.IdDn > 0) {
					data.IdDn = this.KhoDeNghiXuatKhoItem.IdDn;
					this.updateKhoDeNghiXuatKho(data, action);
					//setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
					return;
				}
				this.addKhoDeNghiXuatKho(data,action);
				//setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
			});
		}
		else{
			if (this.KhoDeNghiXuatKhoItem.IdDn > 0) {
				data.IdDn = this.KhoDeNghiXuatKhoItem.IdDn;
				this.updateKhoDeNghiXuatKho(data, action);
				//setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
				return;
			}
			this.addKhoDeNghiXuatKho(data,action);
			//setTimeout(() => this.focusDetail.first.nativeElement.focus(), 500);
		}
		

	}

	updateKhoDeNghiXuatKho(item: KhoDeNghiXuatKho, withBack: number = 0){
		this.KhoDeNghiXuatKhoService.edit(item).subscribe(res => {
			if (res && res.status == 1) {
				const message = 'Phiếu đề nghị xuất kho ' +res.data.Sophieu+' cập nhật thành công.';
				this.layoutUtilsService.showInfo(message);

				this.KhoDeNghiXuatKhoSubForm.controls['NGAYCAN'].setValue(new Date());
				//this.KhoDeNghiXuatKhoSubForm.controls['GHICHU'].setValue('');
				//const __id = 6;
				// const __message_notif = "Bạn có 1 đề nghị xuất kho đang chờ duyệt.";
				// if(withBack == 1 || withBack == 2) this.addNotification(__id,__message_notif);

				// Cập nhật lại khi đã thêm
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);

				// Lưu nháp
				if(withBack == 0){
					this.KhoDeNghiXuatKhoItem = res.data;
					// setTimeout(() => {
					// 	this.focusDetail.first.nativeElement.focus();
					// }, 0);
					this.changeDetect.detectChanges();
					return;
				}
				this.checkGuiDuyet(false);

				// Lưu và thêm mới
				if(withBack == 2){
					let idPhongBan = '';
					this.tokenStorage.getCoCauId().subscribe(a => {idPhongBan = ''+a;});

					this.KhoDeNghiXuatKhoItem = new KhoDeNghiXuatKho();
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
					this.createBillNumber().then(r => {this.KhoDeNghiXuatKhoForm.controls['SOPHIEU'].setValue(r);});
					this.KhoDeNghiXuatKhoForm.controls['NGAYLAP'].setValue(new Date());
					this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[0].value);
					this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue('0');
					// setTimeout(() => {
					// 	this.focusDetail.first.nativeElement.focus();
					// }, 0);
					this.changeDetect.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if(withBack == 1){
					this.KhoDeNghiXuatKhoForm.reset();
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
					this.back();
				}


			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	addKhoDeNghiXuatKho(item: KhoDeNghiXuatKho, withBack: number = 0){
		this.KhoDeNghiXuatKhoService.insert(item).subscribe(res => {
			if(res && res.status == 1){
				const message = 'Phiếu đề nghị xuất kho ' +res.data.Sophieu+' tạo mới thành công.';
				this.layoutUtilsService.showInfo(message);

				// const __id = 6;
				// const __message_notif = "Bạn có 1 đề nghị xuất kho đang chờ duyệt.";
				// if(withBack == 1 || withBack == 2) this.addNotification(__id,__message_notif);

				// Cập nhật lại khi đã thêm
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);

				this.KhoDeNghiXuatKhoSubForm.controls['NGAYCAN'].setValue(new Date());
				//this.KhoDeNghiXuatKhoSubForm.controls['GHICHU'].setValue('');

				// Lưu nháp
				if(withBack == 0){
					this.KhoDeNghiXuatKhoItem = res.data;
					// setTimeout(() => {
					// 	this.focusDetail.first.nativeElement.focus();
					// }, 0);
					this.changeDetect.detectChanges();
					return;
				}
				
				this.checkGuiDuyet(false);

				// Lưu và thêm mới
				if(withBack == 2){
					let idPhongBan = '';
					this.tokenStorage.getCoCauId().subscribe(a => {idPhongBan = ''+a;});

					this.KhoDeNghiXuatKhoItem = new KhoDeNghiXuatKho();
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
					this.createBillNumber().then(r => {this.KhoDeNghiXuatKhoForm.controls['SOPHIEU'].setValue(r);});
					this.KhoDeNghiXuatKhoForm.controls['NGAYLAP'].setValue(new Date());
					this.KhoDeNghiXuatKhoForm.controls['TRANGTHAI'].setValue(this.Tinhtrang[0].value);
					this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue('0');
					// setTimeout(() => {
					// 	this.focusDetail.first.nativeElement.focus();
					// }, 0);
					this.changeDetect.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if(withBack == 1){
					this.KhoDeNghiXuatKhoForm.reset();
					this.tmpChiTietKhoDeNghiXuatKho = [];
					this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
					this.back();
				}
			}else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		})
	}
	// Gửi thông báo
	addNotification(IdNof: number, Message: string){
		this.DungChungService.sendNotificationsToSetting(IdNof,Message).subscribe(res => {});
	}

	//#endregion Xử lý save và gọi api

	//#region Hàng hóa
	ListId_HH(){
		this.deNghiMuaHangService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetect.detectChanges();
			};
		});
	}

	filterId_HH(searchTmp: string = '') {
		let tmpListHH = [];
		tmpListHH = this.listId_HH;
		if (!tmpListHH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' )
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = tmpListHH.length;
			this.filteredId_HH.next(tmpListHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.sumRecord = tmpListHH.filter(ts =>ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				tmpListHH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.sumRecord = tmpListHH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				tmpListHH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetect.detectChanges();
	}

	afterSelectHH(value:string){
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.listId_HH.forEach( element => {
			if(element.Id_HH == +value){
				this.selectId_HH = value;
				controls["MAHH"].setValue(element.MaHH);
				controls["MAHH"].disable();
				controls["TENHH"].setValue(element.TenHH);
				controls["QUYCACH"].setValue(element.QuyCach);
				controls["DVT"].setValue(element.TenDVT);
				controls["KHOILUONG"].setValue(this.f_currency_VND(this.formatNumber('0')));
				let ton = element.TongSoLuongTon;
				controls["SLTON"].setValue(this.f_currency_VND(this.formatNumber(ton)));
				//controls["KHOILUONG"].setValidators([Validators.compose([Validators.required, Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
				this.validateInvalidSubForm();
			}
		});

	}

	clearSelectHH(event: any){
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.selectId_HH = '';
		controls["MAHH"].setValue('');
		controls["TENHH"].setValue('');
		controls["QUYCACH"].setValue('');
		controls["DVT"].setValue('');
		controls["SLTON"].setValue(this.f_currency_VND(this.formatNumber('0')));
		controls["KHOILUONG"].setValue(this.f_currency_VND(this.formatNumber('0')));
		//controls["KHOILUONG"].setValidators([Validators.compose([Validators.required,Validators.maxLength(24),Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
		controls["MAHH"].enable();
		//event.stopPropagation();
		//let _idSPDHB = +this.KhoDeNghiXuatKhoSubForm.controls['SOPHIEUDHB'].value;
		// if(_idSPDHB && _idSPDHB > 0){
		// 	this.selectedSPDHB(_idSPDHB.toString());
		// }else{
		// 	this.sumRecord = this.listId_HH.length;
		// 	this.filteredId_HH.next(this.listId_HH.slice());
		// }

		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
	}
	//#endregion Hàng hóa

	//#region Chuyển tab
	tabChange(event: MatTabChangeEvent){
		
		if(event.index == 0){
			this.resetSubForm();
			// setTimeout(() => {
			// 	this.focusDetail.first.nativeElement.focus();
			// }, 500);

			
		}
		this.changeDetect.detectChanges();
	}
	//#endregion Chuyển tab

	//#region Reset Form
	resetSubForm(){
		let dateCurrent = this.KhoDeNghiXuatKhoSubForm.controls['NGAYCAN'].value;
		let mucDichCurrent = this.KhoDeNghiXuatKhoSubForm.controls['MUCDICHSUDUNG'].value;

		this.KhoDeNghiXuatKhoSubForm.reset();
		this.KhoDeNghiXuatKhoSubForm.controls['MAHH'].setValue("");
		this.selectId_HH = '';
		this.selectListSPDHB = '';
		this.KhoDeNghiXuatKhoSubForm.controls['MAHH'].enable();
		this.KhoDeNghiXuatKhoSubForm.controls['SLTON'].setValue("0,00");
		this.KhoDeNghiXuatKhoSubForm.controls['NGAYCAN'].setValue(dateCurrent);
		this.KhoDeNghiXuatKhoSubForm.controls['KHOILUONG'].setValue("0,00");
		this.KhoDeNghiXuatKhoSubForm.controls['MUCDICHSUDUNG'].setValue(mucDichCurrent);
		//this.KhoDeNghiXuatKhoSubForm.controls['GHICHU'].setValue(ghiChuCurrent);
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
	}
	//#endregion Reset Form

	//#region Change DOM
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	//#endregion Change DOM

	//#region Import
	Importfile() {
		let el: any = this.fileUploadImport.nativeElement;
		var service = this.KhoDeNghiXuatKhoService;

		for (var idx = 0; idx < el.files.length; idx++) {

			var extension = el.files[idx].name.split('.').pop();
			var fileName = el.files[idx].name.substring(0,el.files[idx].name.indexOf(extension) - 1);

			let reader = new FileReader();
			reader.readAsDataURL(el.files[idx]);

			reader.onload = function () {
				let base64Str = reader.result as String;
				var metaIdx = base64Str.indexOf(';base64,');
				base64Str = base64Str.substr(metaIdx + 8);

				var data = {
					fileName: fileName,
					base64: base64Str,
					extension: extension
				};

				service.lastFileUpload$.next(data);
				service.uploadFileImport(data).subscribe(res => {
					if (res && res.status == 1) {
						service.data_import.next(res.data);
					}
					else {
						service.lastFilterDSExcel$.next([]);
						service.lastFilterInfoExcel$.next(undefined);
						return;
					}
				});
			};
		}
	}

	clearErrorData(){
		for(let i = 0 ; i < this.tmpChiTietKhoDeNghiXuatKho.length;i++){
			if(this.tmpChiTietKhoDeNghiXuatKho[i].isError){
				this.tmpChiTietKhoDeNghiXuatKho.splice(i, 1);
				i--;
			}
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	checkErrorData(){
		for(let i = 0 ; i < this.tmpChiTietKhoDeNghiXuatKho.length;i++){
			if(this.tmpChiTietKhoDeNghiXuatKho[i].isError){
				return true;
			}
		}
		return false;
	}

	
	
	clearDataImport(){
		this.KhoDeNghiXuatKhoService.data_import.next([]);
	}

	selectFile(fileUploadImport: any) {
		let el: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
		el.click();
		
	}

	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			let file = evt.target.files[0];
			let fileName = file.name;
			var res = fileName.match(/.xlsx$/g);
			if (res) {
				if (!res["includes"]('.xlsx')) {
					this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
					return;
				}
				else {
					this.ImportHHForm.controls['FileDuLieu'].patchValue(fileName);
					//this.KhoDeNghiXuatKhoForm.controls['LoaiPhieu'].disable();
					this.processImport = true;
					this.changeDetectView();
					this.Importfile();
				}
			}
			else {
				this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
				return;
			}
		}
		else {//Không có file
			this.ImportHHForm.controls['FileDuLieu'].patchValue('');
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	//#endregion Import

	//#region Kiểm tra định dạng số lượng 
	keyUpInputKhoiLuong(event){
		FunctionPublic.preventAlpha(event);
	}

	changeInputKhoiLuong(event, columnName){
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChanged(event);
			if(data){
				this.KhoDeNghiXuatKhoSubForm.controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				this.changeDetect.detectChanges();
			}
		}
		
	}
	//#endregion Kiểm tra định dạng số lượng

	//#region Hàm kiểm tra trường hợp lỗi số lượng
	showErrorInputSL(){
		let message = "";
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		if(controls['KHOILUONG'].value.length == 0 || this.formatComparenumber(controls['KHOILUONG'].value) == 0) return 'Số lượng <b>là bắt buộc</b>';
		if(controls['KHOILUONG'].hasError('maxlength') 
			|| (controls['KHOILUONG'].value.length > 22 
				&& (controls['KHOILUONG'].value.indexOf('.') == 0 || controls['KHOILUONG'].value.indexOf('.') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		if(this.formatComparenumber(controls['SLTON'].value) === 0 && controls['MAHH'].value) return 'Hết hàng';
		//if(this.formatComparenumber(controls['SLTON'].value) > 0) message+= 'Vượt số lượng tồn!';
		return message;
	}
	//#endregion Hàm kiểm tra trường hợp lỗi số lượng

	selectedSPDHB(event){
		let tmp = event.value ? event.value : event;
		if(tmp){
			var index = this.listListSPDHB.findIndex(x => x.Id == +tmp);
			if(index > -1){
				this.KhoDeNghiXuatKhoSubForm.controls['MAKH'].setValue(this.listListSPDHB[index].MaKH);
				this.KhoDeNghiXuatKhoSubForm.controls['TENKH'].setValue(this.listListSPDHB[index].TenKH);
				let listHH = [];
				if(this.listListSPDHB[index].ListHH.length > 0){
					listHH = this.listId_HH.filter(x => this.listListSPDHB[index].ListHH.indexOf(x.Id_HH) > -1);
					this.sumRecord = listHH.length;
					this.filteredId_HH.next(listHH.slice());
				}
				else{
					this.sumRecord = 0;
					this.filteredId_HH.next([]);
				}
				let controls = this.KhoDeNghiXuatKhoSubForm.controls;
				this.selectId_HH = '';
				controls["MAHH"].setValue('');
				controls["TENHH"].setValue('');
				controls["QUYCACH"].setValue('');
				controls["DVT"].setValue('');
				controls["SLTON"].setValue(this.f_currency(this.formatNumber('0')));
				//controls["KHOILUONG"].setValidators([Validators.compose([Validators.required,Validators.maxLength(24),Validators.max(this.formatComparenumber(controls['SLTON'].value)),Validators.pattern('^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\\.[0-9]{1,})?|([1-9]([0-9]+)?)(\\.[0-9]{1,})?|[0](\\.([1-9][0-9]?|[0][1-9])))$')]),this.maxNumberValidator]);
				controls["MAHH"].enable();
			}
			this.changeDetect.detectChanges();
		}
	}

	closeDropdownEvent(dropdownName: string){
		if(dropdownName == 'SoPhieuDHB'){
			setTimeout(() => this.focusSoPhieuDHB.first.close(), 0);
			this.changeDetect.detectChanges();
		}
		this.changeDetect.detectChanges();
	}

	clearSelectSPDHB(event: any){
		let controls = this.KhoDeNghiXuatKhoSubForm.controls;
		this.selectListSPDHB = '';
		// controls["MAKH"].setValue('');
		// controls["TENKH"].setValue('');
		// controls["SOPHIEUDHB"].setValue('');
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
		this.clearSelectHH(event);
		//event.stopPropagation();
	}

	timKiemNangCao(){
		this.openTimKiemNangCao = true;
		
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.focusDetail.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}

	xuLyDauVaoCTSLT(form: boolean = true, item: KhoDeNghiXuatKhoChiTiet = null){
		
		if(form){
			if(!this.selectId_HH){
				this.layoutUtilsService.showErorr("Vui lòng chọn hàng hoá trước khi xem chi tiết số lượng tồn");
				return;
			}
			var Id_HH = Number(this.selectId_HH);
			var index = this.listId_HH.findIndex(x => x.Id_HH == Id_HH);
			if(index > -1){
				this.chiTietSoLuongTon(Id_HH, this.listId_HH[index].MaHH + " - " + this.listId_HH[index].TenHH );
			}
		}else{
			if(item != null){
				this.chiTietSoLuongTon(item.IdHh, item.MaHH + " - " + item.TenHH);
			}
		}
	}

	chiTietSoLuongTon(IdHH: number, Ma_Ten_HH: string){
		this.openTimKiemNangCao = true;
		if (!this.dialogRef) return;
		
		const dialogRef = this.dialog.open(ChiTietSoLuongTonComponent, {
			data: {
				IdHH : IdHH,
				Ma_Ten_HH : Ma_Ten_HH
			},
			maxHeight: '90vh',
			width: '85vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
		});
	}

	changeTypeOfVote(event: any){
		
		// var flag = false;
		// var openDHBOld = this.openDHB;
		// this.optionLoaiPhieu.forEach(x => {
		// 	if(x.Id.toString() == event.value){
		// 		flag = true;
		// 		this.openDHB = x.OpenDHB;
		// 	};
		// });
		// if(!flag){
		// 	this.openDHB = false;
		// };

		// if(openDHBOld != this.openDHB && this.tmpChiTietKhoDeNghiXuatKho.length > 0){
		// 	const dialogRef = this.layoutUtilsService.POPConfirm();
		// 	dialogRef.afterClosed().subscribe(res => {
		// 		if (!res) {
		// 			this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(this.flagChangeLoaiPhieu.toString())
		// 			return;
		// 		}
		// 		this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(event.value.toString())
		// 		this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value.toString();
		// 	});
		// }

		//this.clearSelectSPDHB(event);
		this.clearSelectHH(event);
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
		// this.tmpChiTietKhoDeNghiXuatKho = [];
		// this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	holdValueLoaiPhieuBeforeChange(){
		this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(this.flagChangeLoaiPhieu.toString());
		this.changeDetectView();
	}
	
	checkChangeLoaiPhieu(value: any){
		if(this.tmpChiTietKhoDeNghiXuatKho.length == 0){
			let index = this.optionLoaiPhieu.findIndex(x => x.Id.toString() == value.toString());
			this.openDHB = this.optionLoaiPhieu[index].OpenDHB;
			this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(value.toString())
			this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value.toString();
		}else{
			let index = this.optionLoaiPhieu.findIndex(x => x.Id.toString() == value.toString());
			if(index > -1){
				let status = this.optionLoaiPhieu[index].OpenDHB == this.openDHB;
				if(!status){
					const dialogRef = this.layoutUtilsService.POPConfirm();
					dialogRef.afterClosed().subscribe(res => {
						if (!res) {
							this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(this.flagChangeLoaiPhieu.toString())
							return;
						}
						this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(value.toString())
						this.openDHB = this.optionLoaiPhieu[index].OpenXHDXL;
						this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value.toString();
						this.acceptChangeLoaiPhieu();
						
					});
				}else{
					this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].setValue(value.toString())
					this.openDHB = this.optionLoaiPhieu[index].OpenXHDXL;
					this.flagChangeLoaiPhieu = this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value.toString();
				}
			}
		}
		this.clearSelectSPDHB(event);
		this.clearSelectHH(event);
		this.sumRecord = this.listId_HH.length;
		this.filteredId_HH.next(this.listId_HH.slice());
		// this.tmpChiTietKhoDeNghiXuatKho = [];
		// this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
	}

	acceptChangeLoaiPhieu(){
		for(var i = this.tmpChiTietKhoDeNghiXuatKho.length - 1; i >= 0; i--){
			this.tmpChiTietKhoDeNghiXuatKho.splice(i, 1);
		}
		this.tmpChiTietKhoDeNghiXuatKho = [...this.tmpChiTietKhoDeNghiXuatKho];
		this.changeDetectView();
	}


	ImportFileMau() {
		// let linkdownload = this.dungChungService.downloadTemplate();
		// window.open(linkdownload);
		this.KhoDeNghiXuatKhoService.downloadTemplate(+this.KhoDeNghiXuatKhoForm.controls['LOAIPHIEU'].value).subscribe(blob => {
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = "IMPORT_DENGHIXUATKHO_MAU";
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		});
	}

	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
			
		}
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			//console.log(controls[controlName].value);
		}
		
	}

	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}

	getNameKH(tmp){
		return (tmp.SoPhieu) + (tmp.IdKH > 0 ? " - " +tmp.MaKH +" - "+tmp.TenKH : "");
	}

	showNameToId(){
		let name = '';
		// 
		// if(this.listListSPDHB.length > 0){
		// 	var item = this.listListSPDHB.filter(x => x.Id == +this.KhoDeNghiXuatKhoSubForm.controls['SOPHIEUDHB'].value);
		// 	if(item.length > 0) name = item[0].SoPhieu;
		// }
		return name ? name : '';
	}

	getPlaceHolder(){
		return "Đang tải...";
	}
}

